import { Component, Input, OnInit, Output, EventEmitter, effect, signal } from '@angular/core';
import { BundleLoaderService } from 'src/app/services/bundle-loader/bundle-loader.service';
import { IOHAppService } from 'src/app/services/ioh-app.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'csx-ioh-info',
  standalone: false,
  templateUrl: './ioh-info.component.html',
  styleUrl: './ioh-info.component.scss'
})
export class IOHInfoComponent implements OnInit {
  @Input() isVisible = false;
  @Output() isVisibleOutputEventEmitter = new EventEmitter<boolean>();
  @Input() terminalCode = '';
  iohEquipmentInfo = signal<any[]>([]);

  constructor(private _bundleLoaderService: BundleLoaderService,private iohAppService: IOHAppService) {
    effect(() => {
      const res = this.iohAppService.iohEquipmentInfoWc$();
      this.iohEquipmentInfo.set([...res ?? []]);
    });
  }
  ngOnInit() {
    this.loadComponentBundle();
  }

  //to load imod-operations-info web component bundle
  loadComponentBundle() {
    if (environment?.appConfig?.webComponents?.realtimeOperationsInfo) {
      if (!customElements.get('csxwc-tos-imod-operations-info')) {
        environment.appConfig.webComponents.realtimeOperationsInfo.forEach(
          url => {
            this._bundleLoaderService.loadBundle(url);
          }
        );
      }
    }
  }

  //to close imod-operations-info web component
  onClose($event) {
    const visibilityState =
      typeof $event === 'boolean'
        ? $event
        : $event?.detail ??
          $event?.target?.isVisible ??
          $event?.srcElement?.isVisible;

    // Ignore startup emissions; close only when component is already open.
    if (this.isVisible && visibilityState === false) {
      this.isVisibleOutputEventEmitter.emit(false);
    }
  }
}
